import {
  createFileRoute,
  type ParsedLocation,
  redirect,
} from '@tanstack/react-router'

import { InsightsLayoutPage } from '@/modules/insights/pages'

// Land on Coverage by default: it renders from already-loaded data, no generation pass needed.
const forceRedirectToCoverage = ({
  location,
  params,
}: {
  location: ParsedLocation
  params: { slug: string }
}) => {
  const basePath = `/projects/${params.slug}/insights`
  if (location.pathname === basePath || location.pathname === `${basePath}/`) {
    throw redirect({ to: `${basePath}/coverage` })
  }
}

export const Route = createFileRoute('/_authenticated/projects/$slug/insights')(
  {
    beforeLoad: forceRedirectToCoverage,
    component: () => <InsightsLayoutPage slug={Route.useParams().slug} />,
  },
)
